<template>
  <div class="count-time">
    <div v-for="(item, i) in timeList" :key="i">{{ padLeftZero(item) }}</div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: {
    //结束时间
    endDate: {
      type: [Number, String],
      required: true,
    },
    //当前时间
    value: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {};
  },
  methods: {
    padLeftZero(n) {
      return n < 10 ? "0" + n : n;
    },
    emit() {
      this.$emit("end");
    },
  },
  computed: {
    timeList() {
        console.log('执行')
      const nowDate = moment(this.value).valueOf();
      const endDate = moment(this.endDate).valueOf();
      const time = Math.max(0, (endDate - nowDate) / 1000);
      const h = parseInt(time / 3600);
      const m = parseInt((time % 3600) / 60);
      const s = (time % 3600) % 60;
      if(time<=0){
         this.$emit("end");
      }
      return [h, m, s];
    },
  },
};
</script>
<style scoped lang='less'>
.count-time {
  display: flex;
  color: #1363F7;
  font-weight: 600;
  text-align: center;
  font-size: 12px;
  align-items: center;

  & > div {
    min-width: 20px;
    padding: 0 4px;
    height: 20px;
    line-height: 20px;
    border-radius: 3px;
    border: 1PX solid #1363F7;
    margin-right: 20px;
    position: relative;

    &:before {
      content: ':';
      position: absolute;
      left: calc(100% + 9px);
    }

    &:last-child:before {
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/countDown.vue